"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedSkuPromoMessages = exports.getProductPromoMessages = exports.getOfferTypeSummaries = exports.getOfferTypeLabelsForVariants = exports.getOfferTypeLabelForVariant = exports.getMessagingToUse = exports.getColourVariantPromoMessages = void 0;
var getOfferTypeLabelForVariant = exports.getOfferTypeLabelForVariant = function getOfferTypeLabelForVariant() {
  var offerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  switch (offerType) {
    case 'ReducedToClear':
      return 'Reduced';
    case 'Promotion':
      return 'Offer';
    default:
      return null;
  }
};
var getOfferTypeLabelsForVariants = exports.getOfferTypeLabelsForVariants = function getOfferTypeLabelsForVariants() {
  var _skus$0$localisedPric;
  var skus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var variantType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (skus.length === 0) {
    return {};
  }
  var skuOfferTypeSummary = {};
  var offerTypeForFirstSku = (_skus$0$localisedPric = skus[0].localisedPrices) === null || _skus$0$localisedPric === void 0 ? void 0 : _skus$0$localisedPric.offerType;
  var allSkusHaveSameOfferType = skus.every(function (sku) {
    var _sku$localisedPrices;
    return ((_sku$localisedPrices = sku.localisedPrices) === null || _sku$localisedPrices === void 0 ? void 0 : _sku$localisedPrices.offerType) === offerTypeForFirstSku;
  });
  skus.forEach(function (sku) {
    var _sku$localisedPrices2;
    skuOfferTypeSummary[sku[variantType]] = allSkusHaveSameOfferType ? null : getOfferTypeLabelForVariant((_sku$localisedPrices2 = sku.localisedPrices) === null || _sku$localisedPrices2 === void 0 ? void 0 : _sku$localisedPrices2.offerType);
  });
  return skuOfferTypeSummary;
};
var getProductPromoMessages = exports.getProductPromoMessages = function getProductPromoMessages() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return product.specialOfferMessages ? product.specialOfferMessages.map(function (specialOfferMessage) {
    return specialOfferMessage.longDescription;
  }) : null;
};
var getColourVariantPromoMessages = exports.getColourVariantPromoMessages = function getColourVariantPromoMessages() {
  var _product$variantGroup;
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ((_product$variantGroup = product.variantGroupSpecialOfferMessages) === null || _product$variantGroup === void 0 ? void 0 : _product$variantGroup.differentiator) === 'colour' ? product.variantGroupSpecialOfferMessages.messagesByDifferentiator && product.variantGroupSpecialOfferMessages.messagesByDifferentiator.map(function (el) {
    return {
      colour: el.colour,
      specialOfferMessages: el.specialOfferMessages ? el.specialOfferMessages.map(function (som) {
        return som.longDescription;
      }) : []
    };
  }) : null;
};
var getSelectedSkuPromoMessages = exports.getSelectedSkuPromoMessages = function getSelectedSkuPromoMessages() {
  var selectedSku = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return selectedSku.messaging ? selectedSku.messaging.map(function (specialOfferMessage) {
    return specialOfferMessage.longDescription;
  }) : null;
};
var getMessagingToUse = exports.getMessagingToUse = function getMessagingToUse(_ref) {
  var _ref$product = _ref.product,
    product = _ref$product === void 0 ? {} : _ref$product,
    _ref$selectedColour = _ref.selectedColour,
    selectedColour = _ref$selectedColour === void 0 ? '' : _ref$selectedColour,
    _ref$selectedSize = _ref.selectedSize,
    selectedSize = _ref$selectedSize === void 0 ? '' : _ref$selectedSize,
    _ref$selectedSku = _ref.selectedSku,
    selectedSku = _ref$selectedSku === void 0 ? {} : _ref$selectedSku;
  var productPromoMessages = getProductPromoMessages(product);
  var selectedSkuPromoMessages = getSelectedSkuPromoMessages(selectedSku);
  if (selectedSize) {
    return selectedSkuPromoMessages || productPromoMessages;
  }
  var colourVariantPromoMessages = getColourVariantPromoMessages(product);
  if (selectedColour) {
    var matchedColour = colourVariantPromoMessages && colourVariantPromoMessages.find(function (el) {
      return el.colour === selectedColour;
    });
    return matchedColour ? matchedColour.specialOfferMessages : productPromoMessages;
  }
  return productPromoMessages;
};
var getOfferTypeSummaries = exports.getOfferTypeSummaries = function getOfferTypeSummaries(_ref2) {
  var product = _ref2.product,
    hasColours = _ref2.hasColours,
    hasSizes = _ref2.hasSizes,
    selectedColour = _ref2.selectedColour;
  var colourOfferTypeSummary;
  var sizeOfferTypeSummary;
  if (product.variantGroupOfferTypeSummary && Object.keys(product.variantGroupOfferTypeSummary).length > 0) {
    colourOfferTypeSummary = product.variantGroupOfferTypeSummary;
    var skusForColour = product.skus.filter(function (sku) {
      return sku.colour === selectedColour;
    });
    sizeOfferTypeSummary = getOfferTypeLabelsForVariants(skusForColour, 'size');
    return {
      colourOfferTypeSummary: colourOfferTypeSummary,
      sizeOfferTypeSummary: sizeOfferTypeSummary
    };
  }
  colourOfferTypeSummary = hasColours ? getOfferTypeLabelsForVariants(product.skus, 'colour') : {};
  sizeOfferTypeSummary = hasSizes ? getOfferTypeLabelsForVariants(product.skus, 'size') : {};
  return {
    colourOfferTypeSummary: colourOfferTypeSummary,
    sizeOfferTypeSummary: sizeOfferTypeSummary
  };
};